import React, { useEffect, useRef } from 'react';
import './values.scss';
import fondo from '../../../media/img/logo_wonderaly.png';

const Values = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="values-company">
      <div className="values-company__mainContainer">
        <div className="values-company__section">
          <h2 className="content__title-backgroundDark">
            Los valores que nos guían
          </h2>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <h3 className="content__text-title-backgroundDark">
            Creemos que la neuropsicología y la ciencia deben estar al servicio
            del arte y la creación audiovisual
          </h3>
        </div>

        <div className="values-company__section">
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Ciencia con propósito creativo
            </p>
            <p className="content__text-paragrah-backgroundDark">
              Aplicamos el conocimiento neuropsicológico de manera rigurosa y
              accesible, conectando la ciencia del comportamiento humano con la
              creación audiovisual para generar un impacto real y medible.
            </p>
          </div>
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Innovación pionera
            </p>
            <p className="content__text-paragrah-backgroundDark">
              Somos referentes en la integración de la neuropsicología en la
              producción cinematográfica, abriendo un camino que transforma cómo
              se crean y se viven las historias audiovisuales.
            </p>
          </div>
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Enfoque humano y empático
            </p>
            <p className="content__text-paragrah-backgroundDark">
              Entendemos que detrás de cada producción hay personas — equipos,
              actores, directores — y nuestro enfoque neuropsicológico potencia
              su bienestar, creatividad y rendimiento.
            </p>
          </div>
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Impacto emocional medible
            </p>
            <p className="content__text-paragrah-backgroundDark">
              No solo creamos experiencias, las medimos. Utilizamos datos, BI e
              IA para cuantificar el impacto emocional de las obras y
              optimizarlas con base en evidencia científica.
            </p>
          </div>
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Compromiso con cada producción
            </p>
            <p className="content__text-paragrah-backgroundDark">
              Nos implicamos en cada proyecto de manera personalizada,
              acompañando a los equipos creativos en cada fase del proceso
              audiovisual con dedicación y rigor científico.
            </p>
          </div>
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Responsabilidad social
            </p>
            <p className="content__text-paragrah-backgroundDark">
              Creemos en el poder del arte para transformar la sociedad. Por eso
              desarrollamos proyectos con impacto social real, como nuestra
              iniciativa de Prevención del Suicidio en Extremadura.
            </p>
          </div>
          <div className="values-company__values">
            <p className="content__text-paragrah-title-backgroundDark">
              Transparencia y confianza
            </p>
            <p className="content__text-paragrah-backgroundDark">
              Construimos relaciones duraderas con productoras e instituciones
              basadas en la comunicación clara, la honestidad y los resultados
              demostrables.
            </p>
          </div>
        </div>
      </div>
      <div className="values-company__background-image-container">
        <img
          src={fondo}
          className="values-company__background-image"
          alt="valores wonderaly"
        />
      </div>
    </div>
  );
};

export default Values;
